import React, { useEffect, useState } from "react";
import logo_left from "../../assets/01_Home/Icon_Left.svg";
import logo_right from "../../assets/01_Home/Icon_Right.svg";
import { useLocation } from "react-router-dom";
import { getSrcSet, getSizes, getResponsiveImage, buildCmsUrl } from "../../utils/imageHelper";
import { Helmet } from "react-helmet-async";

/*eslint-disable */

declare const window: any;

interface BannerComponentProps {
  dataBanner: any;
}

const BannerComponent: React.FC<BannerComponentProps> = ({ dataBanner }) => {
  const location = useLocation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // Determinamos la orientación para escoger entre media o media_portrait
  const [orientation, setOrientation] = useState(
    window.innerWidth > window.innerHeight ? "landscape" : "portrait"
  );

  // Almacena los índices de las imágenes que ya se cargaron para evitar “flash” posterior
  const [loadedImages, setLoadedImages] = useState<Set<number>>(new Set());

  // Manejo de gestos táctiles
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);

  // Efecto para manejar visibilidad inicial y cambio de orientación
  useEffect(() => {
    const handleLoad = () => {
      setIsVisible(true);
    };

    const updateOrientation = () => {
      setOrientation(
        window.innerWidth > window.innerHeight ? "landscape" : "portrait"
      );
    };

    handleLoad();
    window.addEventListener("resize", updateOrientation);
    return () => {
      window.removeEventListener("resize", updateOrientation);
    };
  }, [location]);

  // Pre-cargamos la imagen de la diapositiva activa (si es de tipo imagen)
  useEffect(() => {
    if (dataBanner[currentIndex]?.media_type === "img") {
      // Determinamos la URL según la orientación
      const imageUrl =
        orientation === "portrait" &&
          dataBanner[currentIndex]?.media_portrait?.url
          ? dataBanner[currentIndex].media_portrait.url
          : dataBanner[currentIndex].media?.url;

      // Si no la hemos cargado antes, la precargamos con un objeto Image()
      if (!loadedImages.has(currentIndex)) {
        const responsiveImg = getResponsiveImage(imageUrl);
        const img = new Image();
        img.src = responsiveImg.desktop;
        img.onload = () => {

          setLoadedImages((prev) => {
            const newSet = new Set(prev);
            newSet.add(currentIndex); // Marcamos que ya se cargó
            return newSet;
          });
        };
      }
    }
  }, [currentIndex, dataBanner, orientation, loadedImages]);

  useEffect(() => {
    // Usar setTimeout para evitar bloquear el hilo principal durante el cambio de slide
    setTimeout(() => {
      const dataLayerEvent: any = {
        event: "hero_banner_view",
        comp_page: {
          name_banner: dataBanner[currentIndex]?.title?.title,
          link: window.location.origin + dataBanner[currentIndex]?.url_button,
        },
      };

      if (window.dataLayer) {
        window.dataLayer.push(dataLayerEvent);
      }
    }, 0);
  }, [currentIndex, dataBanner]);

  // Efecto para disparar evento en dataLayer y rotar el banner automáticamente
  useEffect(() => {
    // Cambio automático de diapositiva si no estamos haciendo hover
    if (!isHovered) {
      const interval = setInterval(() => {
        goToNext();
      }, 7000);
      return () => clearInterval(interval);
    }
  }, [currentIndex, isHovered, dataBanner]);

  // Funciones para cambiar diapositiva
  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? dataBanner.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    const isLastSlide = currentIndex === dataBanner.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  // Gestos táctiles
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    if (distance > 50) goToNext();
    if (distance < -50) goToPrevious();
    setTouchStart(null);
    setTouchEnd(null);
  };

  // Evento para tracking cuando se hace clic en el banner
  const handlesendBannerDataLayer = () => {
    // Usar setTimeout para evitar bloquear el hilo principal en la interacción
    setTimeout(() => {
      const dataLayerEvent: any = {
        event: "hero_banner_click",
        comp_page: {
          name_banner: dataBanner[currentIndex]?.title?.title,
          link: window.location.origin + dataBanner[currentIndex]?.url_button,
        },
      };
      if (window.dataLayer) {
        window.dataLayer.push(dataLayerEvent);
      }
    }, 0);
  };

  const firstSlideImageUrlMobile = dataBanner?.[0]?.media_type === "img" && dataBanner[0]?.media_portrait?.url ? dataBanner[0].media_portrait.url : dataBanner?.[0]?.media?.url;
  const firstSlideImageUrlDesktop = dataBanner?.[0]?.media_type === "img" ? dataBanner[0].media?.url : null;
  const mobileFallback = firstSlideImageUrlMobile ? getResponsiveImage(firstSlideImageUrlMobile).mobile : '';
  const desktopFallback = firstSlideImageUrlDesktop ? getResponsiveImage(firstSlideImageUrlDesktop).desktop : '';

  return (
    <>
      <Helmet>
        {mobileFallback && (
          <link rel="preload" as="image" href={mobileFallback} media="(max-width: 768px)" fetchPriority="high" />
        )}
        {desktopFallback && (
          <link rel="preload" as="image" href={desktopFallback} media="(min-width: 769px)" fetchPriority="high" />
        )}
      </Helmet>
      <div
        className="banner-home-component"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
      {/* Contenedor del slider, se mueve en X según el currentIndex */}
      <div
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        className="slider-banner-home-component"
      >
        {dataBanner?.map((image: any, index: number) => {
          // Si es imagen, usamos el background solo si es la diapositiva activa o si ya fue cargada
          if (image.media_type === "img") {
            const shouldDisplayBackground =
              currentIndex === index || loadedImages.has(index);
            const imageUrl =
              orientation === "portrait" &&
                image?.media_portrait?.url !== undefined
                ? image.media_portrait.url
                : image.media?.url;

            return (
              <div
                key={index}
                className={`active-img-banner-home-component with-margin ${isVisible ? "visible" : ""
                  } ${image?.template === 1 ? "template-1" : "template-2"} ${shouldDisplayBackground ? "" : "loading-bg"
                  }`}
                style={{
                  backgroundColor: "#f0f0f0",
                  position: "relative",
                  overflow: "hidden",
                  opacity: index === 0 ? 1 : undefined,
                  transition: index === 0 ? "none" : "all 0.5s ease-in-out",
                }}
              >
                {shouldDisplayBackground && (
                  <img
                    src={getResponsiveImage(imageUrl).desktop}
                    srcSet={getSrcSet(imageUrl)}
                    sizes="100vw"
                    alt={image.title?.title || "Banner Principal Hyundai"}
                    {...({ fetchpriority: index === 0 ? "high" : "auto" } as any)}
                    loading={index === 0 ? "eager" : "lazy"}
                    width="1920"
                    height="840"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      zIndex: 0,
                      pointerEvents: "none"
                    }}
                  />
                )}
                {shouldDisplayBackground ? (
                  <>
                    {/* Título y descripción */}
                    {image.title !== null && (
                      <div
                        className={`${image.title.size === "large"
                            ? "large-title-active-img-banner-home-component"
                            : image.title.size === "small"
                              ? "small-title-active-img-banner-home-component"
                              : "medium-title-active-img-banner-home-component"
                          } ${isVisible ? "visible" : ""} ${image?.template === 1 ? "template-1" : "template-2"
                          }`}
                        style={{ color: image.title.text_color.color, zIndex: 1 }}
                      >
                        <h1 style={{ margin: 0, padding: 0, fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit', fontFamily: 'inherit', lineHeight: 'inherit', display: 'inline' }}>
                          {image.title.title}
                        </h1>
                        {image?.description && (
                          <div
                            className="description-active-img-banner-home-component"
                            dangerouslySetInnerHTML={{
                              __html: image?.description,
                            }}
                          ></div>
                        )}
                      </div>
                    )}

                    {/* Botón principal */}
                    {image?.text_button !== null && (
                      <a
                        className={`button-sello-active-img-banner-home-component ${isVisible ? "visible" : ""
                          } ${image?.color_button?.name}`}
                        style={{
                          backgroundColor: image?.color_button?.color,
                          color: image?.text_color?.color,
                          zIndex: 1
                        }}
                        href={image?.url_button}
                        target={image?.url_onnewtab ? "_blank" : ""}
                        onClick={handlesendBannerDataLayer}
                      >
                        {image?.text_button}
                      </a>
                    )}

                    {/* Sello de seguridad (imagen) */}
                    {image?.security_seal !== null && (
                      <div
                        className={`individual-sello-active-img-banner-home-component ${isVisible ? "visible" : ""
                          } ${image?.template === 1 ? "template-1" : "template-2"
                          } ${image?.security_seal?.size}`}
                        style={{ zIndex: 1 }}
                      >
                        <img
                          loading="lazy"
                          src={buildCmsUrl(image?.security_seal?.image?.url)}
                          srcSet={getSrcSet(image?.security_seal?.image?.url)}
                          sizes={getSizes('100px')}
                          alt={
                            image?.security_seal?.alt ||
                            "Sello de seguridad Hyundai"
                          }
                          width="100"
                          height="100"
                        />
                      </div>
                    )}

                    {/* Info comercial (tarjeta) */}
                    {image?.commercial_info !== null && (
                      <a
                        href={image?.commercial_info?.url}
                        target={
                          image?.commercial_info?.url_onnewtab ? "_blank" : ""
                        }
                        className={`tarjeta-sello-active-img-banner-home-component ${image?.template === 1 ? "template-1" : "template-2"
                          }`}
                        style={{ zIndex: 1 }}
                      >
                        <span className="precio-desde-tarjeta-sello-active-img-banner-home-component">
                          {image?.commercial_info?.textfield1}
                        </span>
                        <h2 className="precio-tarjeta-sello-active-img-banner-home-component" style={{ margin: 0 }}>
                          {image?.commercial_info?.textfield2}
                        </h2>
                        <span className="descripcion-tarjeta-sello-active-img-banner-home-component">
                          {image?.commercial_info?.textfield3}
                        </span>
                        <span className="terminos-tarjeta-sello-active-img-banner-home-component">
                          {image?.commercial_info?.textfield4}
                        </span>
                      </a>
                    )}
                  </>
                ) : null}
              </div>
            );
          } else {
            // Caso de video: se renderiza solo si es la diapositiva activa
            return (
              <div
                key={index}
                className={`active-video-banner-home-component ${isVisible ? "visible" : ""
                  }`}
              >
                {currentIndex === index && (
                  <video
                    src={buildCmsUrl(image?.media?.url)}

                    autoPlay
                    muted
                    loop
                    playsInline
                  ></video>
                )}
                {/* Resto del contenido para videos */}
              </div>
            );
          }
        })}
      </div>

      {/* Controles de navegación del banner */}
      <div
        className={`control-banner-home-component ${isVisible ? "visible" : ""
          }`}
      >
        <div
          className="left-control-banner-home-component"
          onClick={goToPrevious}
        >
          <img src={logo_left} alt="Botón para retroceder banner" width="20" height="20" />
        </div>
        <div className="center-control-banner-home-component">
          {dataBanner.map((image: any, index: number) => (
            <div onClick={() => setCurrentIndex(index)} key={index}>
              <img
                loading="lazy"
                src={buildCmsUrl(
                  image?.thumbnail?.formats?.small !== undefined
                    ? image?.thumbnail?.formats?.small?.url
                    : image?.thumbnail?.url
                )}


                srcSet={getSrcSet(
                  image?.thumbnail?.formats?.small !== undefined
                    ? image?.thumbnail?.formats?.small?.url
                    : image?.thumbnail?.url
                )}
                sizes={getSizes('100px')}
                alt={
                  image?.thumbnail?.alt || `Miniatura ${index + 1} del banner`
                }
                width="118"
                height="80"
              />

              <div
                className={`mascara-center-control-banner-home-component ${currentIndex === index ? "active" : ""
                  }`}
              ></div>
            </div>
          ))}
        </div>
        <div className="right-control-banner-home-component" onClick={goToNext}>
          <img src={logo_right} alt="Botón para avanzar banner" width="20" height="20" />
        </div>
      </div>
    </div>
    </>
  );
};

export default BannerComponent;
